import React from 'react';
import Picture from '../common/Picture';
import { withTranslation } from 'react-i18next';
const FaqForm = ({ t }) => {
  return (
    <div className="faqForm">
      <div className="formContent">
        <div className="leftarea">
          <div className="helpBottomHeader">
            {t('Can’t find what you’re looking for?')}
          </div>
          <p>
            {t(
              'Call our toll free number below or submit a support request on the '
            )}
            <br className="desktop-only" />
            {t('right and we will get back to you shortly.')}
          </p>
          <div className="callUs">
            <Picture imagePath="icons/PhoneIcon" imgClass="phoneIcon" alt="" />
            <div>
              <label> {t('Toll')} </label> <br />
              <a href="tel:844-234-3057">844-234-3057</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(FaqForm);
